import { SEARCH_SEPARATOR } from '../../../../helpers/defaults';
import {
  getCommutesFromUrl,
  getSearchFlowFromUrl,
} from '../../../../helpers/queryStringHelpers/queryStringHelpers';
import type { CommuteMethod } from '../types';

export interface CommuteFilters {
  placeId: string;
  time: number;
  method: CommuteMethod;
}

export const SEARCH_PAGE_COMMUTE_PLACE_ID_FALLBACK = 'ChIJa8NU3FJC1moR4pG3j4xGppc'; // REA Group PlaceId as fallback
export const SEARCH_PAGE_COMMUTE_TIME_FALLBACK = '5';
export const SEARCH_PAGE_COMMUTE_METHOD_FALLBACK = 'driving';

export const getCommuteFiltersFromUrl = (url: string): CommuteFilters | null => {
  const commutes = getCommutesFromUrl(url);
  const flow = getSearchFlowFromUrl(url);

  if (flow !== 'commute') return null;

  const [placeId, commuteMethod, commuteTime] = commutes.split(SEARCH_SEPARATOR);

  return {
    placeId: placeId || SEARCH_PAGE_COMMUTE_PLACE_ID_FALLBACK,
    method: (commuteMethod || SEARCH_PAGE_COMMUTE_METHOD_FALLBACK) as CommuteMethod,
    time: Number(commuteTime || SEARCH_PAGE_COMMUTE_TIME_FALLBACK),
  };
};
